// removed by extract-text-webpack-plugin
module.exports = {"root":"ServicesList-module-root-3MgkH","section-title":"ServicesList-module-section-title-dwA3O","sectionTitle":"ServicesList-module-section-title-dwA3O","listing":"ServicesList-module-listing-1FJBH","item":"ServicesList-module-item-1zka3","img":"ServicesList-module-img-1ckv-","item-title":"ServicesList-module-item-title-1Mxv2","itemTitle":"ServicesList-module-item-title-1Mxv2","title-text":"ServicesList-module-title-text-16uIt","titleText":"ServicesList-module-title-text-16uIt","description":"ServicesList-module-description-Ovr7f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ServicesList/ServicesList.module.scss
// module id = 1085
// module chunks = 0